import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ValidateOtpPageComponent } from './validate-otp-page.component';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'validateOtp',
    url: '/validateOtp',
    component: ValidateOtpPageComponent,
    data: {
      requireLogin: false
    },
    params: {
      message: null,
      userObject: null,
      loginParamsObject: null
    }
  }
];

@NgModule({
  declarations: [ValidateOtpPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ValidateOtpPageComponent]
})
export class ValidateOtpPageModule { }
